import { render, staticRenderFns } from "./ProfilePersonForm.vue?vue&type=template&id=3616f2e2&"
import script from "./ProfilePersonForm.vue?vue&type=script&lang=js&"
export * from "./ProfilePersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports